import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-401e2ffd")

_pushScopeId("data-v-401e2ffd")
const _hoisted_1 = {
  key: 0,
  class: "service-list-container"
}
const _hoisted_2 = { class: "order-image-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_empty = _resolveComponent("van-empty")

  return (_ctx.isShow)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_van_image, {
          width: "100vw",
          height: "135.2vw",
          fit: "fill",
          src: require('@/assets/image/pingwei/header.png')
        }, null, 8, ["src"]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_van_image, {
            width: "60px",
            src: require('@/assets/image/pingwei/order-image.png'),
            onClick: _ctx.gotoOrderList
          }, null, 8, ["src", "onClick"])
        ]),
        (_ctx.serviceGroup.length >0)
          ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.serviceGroup, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "service-group",
                key: index
              }, [
                _createVNode(_component_van_button, {
                  color: "linear-gradient(to bottom, #FF5320, #FFAD5C)",
                  class: "group-icon",
                  size: "normal"
                }, {
                  default: _withId(() => [
                    _createTextVNode(" ·" + _toDisplayString(item.name) + "· ", 1)
                  ]),
                  _: 2
                }, 1024),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.list, (itemchlid, indexChild) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "image-container",
                    key: indexChild
                  }, [
                    (itemchlid.productId)
                      ? (_openBlock(), _createBlock(_component_van_image, {
                          key: 0,
                          width: "100%",
                          fit: "fill",
                          onClick: ($event: any) => (_ctx.gotoService(itemchlid)),
                          src: itemchlid.imageUrl
                        }, null, 8, ["onClick", "src"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            }), 128))
          : (_openBlock(), _createBlock(_component_van_empty, {
              key: 1,
              class: "service-group-empty",
              description: "暂无产品"
            })),
        _createVNode(_component_van_image, {
          width: "100%",
          fit: "fill",
          src: require('@/assets/image/pingwei/footer.png')
        }, null, 8, ["src"])
      ]))
    : _createCommentVNode("", true)
})